// extracted by mini-css-extract-plugin
export default {"errorModalText":"ErrorModal_errorModalText__ZTOkm","errorModalBtnGroup":"ErrorModal_errorModalBtnGroup__1kvGV","groupBtn2":"ErrorModal_groupBtn2__8OMCf"};